import { assessmentKitsConstants } from "../../_constants";

const initialState = {};

export const create_assessment_kit_reducer = (state = initialState, action) => {
  switch (action.type) {
    case assessmentKitsConstants.CREATE_ASSESSMENT_KIT_ACTION_REQUEST:
    case assessmentKitsConstants.GET_ASSESSMENT_KIT_BY_ID_ACTION_REQUEST:
    case assessmentKitsConstants.SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_REQUEST:
    case assessmentKitsConstants.UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_REQUEST:
      // case assessmentKitsConstants.DELETE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case assessmentKitsConstants.CREATE_ASSESSMENT_KIT_ACTION_SUCCESS:
    case assessmentKitsConstants.GET_ASSESSMENT_KIT_BY_ID_ACTION_SUCCESS:
    case assessmentKitsConstants.SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_SUCCESS:
    case assessmentKitsConstants.UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_SUCCESS:
      // case assessmentKitsConstants.DELETE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        createAssessmentData: action.payload,
      };
    case assessmentKitsConstants.CREATE_ASSESSMENT_KIT_ACTION_FAILURE:
    case assessmentKitsConstants.GET_ASSESSMENT_KIT_BY_ID_ACTION_FAILURE:
    case assessmentKitsConstants.SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_FAILURE:
    case assessmentKitsConstants.UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_FAILURE:
      // case assessmentKitsConstants.DELETE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// get all assessment kits
export const get_all_assessment_kits_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case assessmentKitsConstants.GET_ALL_ASSESSMENT_KIT_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case assessmentKitsConstants.GET_ALL_ASSESSMENT_KIT_ACTION_SUCCESS:
      return {
        type: "alert-success",
        allPublishedAssessmentData: action.payload,
      };
    case assessmentKitsConstants.GET_ALL_ASSESSMENT_KIT_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// / get all assigned assessment kits
export const get_assigned_candidates_to_assessment_kit_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case assessmentKitsConstants.GET_ASSESSMENT_KITS_CANDIDATES_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case assessmentKitsConstants.GET_ASSESSMENT_KITS_CANDIDATES_ACTION_SUCCESS:
      return {
        type: "alert-success",
        assessmentKitCandidatesData: action.payload,
      };
    case assessmentKitsConstants.GET_ASSESSMENT_KITS_CANDIDATES_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// / get all assessment kits
export const get_candidate_assessment_response_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case assessmentKitsConstants.VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case assessmentKitsConstants.VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        candidateResponseData: action.payload,
      };
    case assessmentKitsConstants.VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_candidate_assigned_assessment_details_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case assessmentKitsConstants.GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case assessmentKitsConstants.GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        assignedAssessmentDetailsData: action.payload,
      };
    case assessmentKitsConstants.GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_skill_topics_data_reducer = (state = initialState, action) => {
  switch (action.type) {
    case assessmentKitsConstants.GET_SKILL_TOPICS_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case assessmentKitsConstants.GET_SKILL_TOPICS_DETAILS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        skillTopicsData: action.payload,
      };
    case assessmentKitsConstants.GET_SKILL_TOPICS_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_assessment_custom_questions_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case assessmentKitsConstants.GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case assessmentKitsConstants.GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        allCustomQuestionsData: action.payload,
      };
    case assessmentKitsConstants.GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_candidates_assessment_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case assessmentKitsConstants.GET_CANDIDATE_ASSESSMENT_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case assessmentKitsConstants.GET_CANDIDATE_ASSESSMENT_ACTION_SUCCESS:
      return {
        type: "alert-success",
        candidateAssessmentVideosData: action.payload,
      };
    case assessmentKitsConstants.GET_CANDIDATE_ASSESSMENT_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
